import { defineStore } from "pinia";
import {ref} from 'vue';

export const infos = defineStore('infos', () => {
    const business = ref(localStorage.getItem('business'));

    function setBusiness(businessValue) {
        localStorage.setItem('business',businessValue);
        business.value = businessValue;
    }

    return {business, setBusiness}
})